var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknownDevice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 55,
    viewBox: "0 0 47 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4539 0.338899C23.388 0.34799 23.3243 0.365162 23.2635 0.389404L1.29968 11.6177C0.988888 11.7359 0.781357 12.0288 0.77832 12.3581V41.847C0.781357 42.1753 0.988888 42.4692 1.29968 42.5874L23.2635 54.8248C23.4518 54.8975 23.6604 54.8975 23.8487 54.8248L45.8115 42.5874C46.1233 42.4692 46.3298 42.1753 46.3339 41.847V12.3581C46.3298 12.0288 46.1233 11.7359 45.8115 11.6177L23.8487 0.389404C23.7231 0.339909 23.5875 0.322738 23.4539 0.338899V0.338899ZM23.5561 1.99648L43.3029 12.3702L23.5561 23.7298L3.80827 12.3702L23.5561 1.99648ZM2.40718 13.5379L22.7412 25.149V52.9035L2.40718 41.2934V13.5379ZM44.704 13.5379V41.2934L24.37 52.9035V25.149L44.704 13.5379Z",
    fill: "#F57F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1694 7.03819L13.2201 18.5301L12.5742 17.4129L32.5225 5.92102L33.1694 7.03819Z",
    fill: "#F57F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownDevice);
export default __webpack_public_path__ + "static/media/UnknownDevice.d44043fd7508025bd2efcc09b13b899b.svg";
export { ForwardRef as ReactComponent };